import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FecImportMappingStepWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S16};
  width: 100%;
  min-height: 0;
`

export const FecImportMappingTabs = styled.div`
  flex-shrink: 0;
  width: 100%;
`

export const FecImportMappingTabPanel = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
`
